import { CategoryPage } from './category.component';
import { connect } from 'react-redux';
import { fetchProducts, addToWishlist, removeToWishlist } from "./../../api/product/productAction";
import { addToCart } from "./../../api/cart/cartAction";

const mapDispatchToProps = {
    fetchProducts,
    addToCart,
    addToWishlist,
    removeToWishlist
};

const mapStateToProps = state => ({
    isLoading: state.productPage.isLoading,
    isAdded: state.productPage.isAdded,
    products: state.productPage.products,
    isLoggedIn: state.userPage.isLoggedIn
});

export const CategoryContainer = connect(mapStateToProps, mapDispatchToProps)(CategoryPage);